import AdminSettingsItem from "../../../components/modals/adminSettings/AdminSettingsItem";
import Button, { BUTTON_TYPES } from "../../../components/Button";
import { useEffect, useState } from "react";
import DeleteModal from "../../../components/modals/DeleteModal";
import toast from 'react-hot-toast';
import ErrorPage from "../../ErrorPage";
import Page from "../../../components/Page";

/**
 * Common component for rendering all items for each settings tab
 */
const FormattedItems = ({ items = [], labelKey, openModal, sortField }) => {
    let sortedItems = items;
    if (sortField) {
        sortedItems = items.sort((a, b) => { return a[sortField] - b[sortField] });
    }
    return sortedItems.map((item) => (
        <AdminSettingsItem
            key={item.id}
            id={item.id}
            value={item[labelKey]}
            openModal={openModal}
        />
    ));
};

/**
 * Common component for all tabs on the Admin Settings page
 */
const AdminSettingsTab = ({ heading, fetchData, modal, labelKey, sortField, deleteAPICall }) => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [apiSuccess, setApiSuccess] = useState(true);

    useEffect(() => {
        (async () => {
            setLoading(true);
            try {
                const data = await fetchData();
                setItems(data);
            } catch {
                setApiSuccess(false);
            } finally {
                setLoading(false);
            }

        })();
    }, [fetchData]);

    const [activeModal, setActiveModal] = useState(null);
    const [currentRequirementToEdit, setCurrentRequirementToEdit] = useState(null);


    const openModal = (modalType, itemID = null) => {
        setActiveModal(modalType);
        itemID && setCurrentRequirementToEdit(items.find(item => item.id === itemID));
    };

    const closeModal = () => {
        setActiveModal(null);
        setCurrentRequirementToEdit(null);
    };

    const handleDelete = async (apiCall, itemID) => {
        try {
            toast.loading("Deleting...");
            const response = await apiCall(itemID);
            setTimeout(async () => {
                if (response.ok) {
                    toast.dismiss();
                    toast.success("Successfully deleted!");
                    setItems((prev) => (prev ?? []).filter((s) => s.id !== itemID));
                    closeModal();
                } else {
                    toast.dismiss();
                    console.log("Error deleting. Status:", response.status);
                    toast.error("Failed to delete. Status: " + response.status);
                }
            }, 500);
        } catch (error) {
            toast.dismiss();
            console.error("Error deleting:", error);
            alert("Something went wrong. Please check your connection and try again.");

        }
    };

    const ModalComponent = modal;

    if (loading) {
        return (
            <Page>
                <div>
                    Loading....
                </div>
            </Page>

        );
    }

    return (
        <>
            {!apiSuccess && <ErrorPage />}
            {apiSuccess && (
                <div className="d-flex flex-column justify-content-between align-items-center mb-5">
                    <h4 className="membership-subheader">{heading}</h4>
                    <FormattedItems
                        items={items}
                        labelKey={labelKey}
                        sortField={sortField}
                        openModal={openModal}
                    />
                    <Button
                        id="add-new-item-button"
                        type={BUTTON_TYPES.primary}
                        buttonText="+ Add"
                        action={() => openModal('add')}
                    />

                    {activeModal === 'edit' &&
                        <ModalComponent
                            isOpen={true}
                            onClose={closeModal}
                            item={currentRequirementToEdit}
                            setItems={setItems}
                        />
                    }
                    {activeModal === 'add' &&
                        <ModalComponent
                            isOpen={true}
                            onClose={closeModal}
                            isAdding
                            setItems={setItems}
                        />
                    }
                    {activeModal === 'delete' &&
                        <DeleteModal
                            isOpen={true}
                            onClose={closeModal}
                            itemToDelete={currentRequirementToEdit}
                            handleDelete={handleDelete}
                            deleteAPICall={deleteAPICall}
                        />
                    }
                </div>
            )}
        </>
    )
};

export default AdminSettingsTab;